export default ({ request }) => ({
  scmAppraisalBillListApi(data) {
    return request({
      url: "/digitalCenter/scmAppraisal/billList",
      method: "post",
      data,
    });
  },
  scmAppraisalBillDetailApi(data) {
    return request({
      url: "/digitalCenter/scmAppraisal/getBill",
      method: "post",
      data,
    });
  },
  scmAppraisalBillSaveApi(data) {
    return request({
      url: "/digitalCenter/scmAppraisal/billSave",
      method: "post",
      data,
    });
  },
  scmAppraisalBillDelApi(data) {
    return request({
      url: "/digitalCenter/scmAppraisal/billDel",
      method: "post",
      data,
    });
  },
  scmAppraisalBillDetailAddApi(data) {
    return request({
      url: "/digitalCenter/scmAppraisal/billDetailAdd",
      method: "post",
      data,
    });
  },
  scmAppraisalBillDetailDelApi(data) {
    return request({
      url: "/digitalCenter/scmAppraisal/billDetailDel",
      method: "post",
      data,
    });
  },
});
